export default __webpack_public_path__ + "static/media/emoji_money_with_wings.b3e85a3d.png";